import { SkResponse } from "../models/SkResponse"

export const GetUndefined = async () => undefined
export const GetNull = async () => null
export const GetEmptyList = async <TItem>(): Promise<SkResponse<TItem[]>> => ({ data: [] }) as unknown as SkResponse<TItem[]>
export const GetValue = async <TValue>(val: TValue) => val